// extracted by mini-css-extract-plugin
export default {"ClassesSection":"styles_ClassesSection__-5xXG","title":"styles_title__1Tdjc"};